var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgTwitch = function SvgTwitch(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#9146FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5713 8.14267H12.7147V11.5713H11.5707L11.5713 8.14267ZM14.7147 8.14267H15.8573V11.5713H14.7147V8.14267ZM7.85733 5L5 7.85733V18.1427H8.42867V21L11.286 18.1427H13.5713L18.7147 13V5H7.85733ZM17.5713 12.4287L15.286 14.714H13L11 16.714V14.714H8.42867V6.14267H17.5713V12.4287Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTwitch);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgyMEMyMi4yMDkxIDAgMjQgMS43OTA4NiAyNCA0VjIwQzI0IDIyLjIwOTEgMjIuMjA5MSAyNCAyMCAyNEg0QzEuNzkwODYgMjQgMCAyMi4yMDkxIDAgMjBWNFoiIGZpbGw9IiM5MTQ2RkYiLz4KPHBhdGggZD0iTTExLjU3MTMgOC4xNDI2N0gxMi43MTQ3VjExLjU3MTNIMTEuNTcwN0wxMS41NzEzIDguMTQyNjdaTTE0LjcxNDcgOC4xNDI2N0gxNS44NTczVjExLjU3MTNIMTQuNzE0N1Y4LjE0MjY3Wk03Ljg1NzMzIDVMNSA3Ljg1NzMzVjE4LjE0MjdIOC40Mjg2N1YyMUwxMS4yODYgMTguMTQyN0gxMy41NzEzTDE4LjcxNDcgMTNWNUg3Ljg1NzMzWk0xNy41NzEzIDEyLjQyODdMMTUuMjg2IDE0LjcxNEgxM0wxMSAxNi43MTRWMTQuNzE0SDguNDI4NjdWNi4xNDI2N0gxNy41NzEzVjEyLjQyODdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";